// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cila","top":"styles_top__1tb_V","left":"styles_left__1HlA6","description":"styles_description__1uJQE"};